
<template>
  <section class="container-fluid">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <div class="row">
                <div class="col-12 col-xl-5"><CIcon name="cil-grid" />Recaudaciones</div>
                <div class="col-12 col-xl-7">
                  <div class="row">
                    <div class="col-12 col-xl-7"></div>
                    <div class="col-12 col-xl-2">
                      <div class="form-group">
                        <label for="created_at_from">Desde</label>
                        <flat-pickr
                          v-model="columnFilter.created_at_from"
                          :config="{
                            dateFormat: 'd-m-Y',
                            showMonths: 1,
                            maxDate: columnFilter.created_at_to,
                          }"
                          @on-change="filterTable"
                          class="form-control form-control-sm"
                        ></flat-pickr>
                      </div>
                    </div>
                    <div class="col-12 col-xl-2">
                      <div class="form-group">
                        <label for="created_at_to">Hasta</label>
                        <flat-pickr
                          v-model="columnFilter.created_at_to"
                          :config="{
                            dateFormat: 'd-m-Y',
                            showMonths: 1,
                            minDate: columnFilter.created_at_from,
                          }"
                          @on-change="filterTable"
                          class="form-control form-control-sm"
                        ></flat-pickr>
                      </div>
                    </div>
                    <div class="col-12 col-xl-1 float-right">
                      <button
                        @click="print()"
                        title="Reporte de venta"
                        class="btn btn-secondary btn-sm mt-3 float-right"
                        type="button"
                      >
                        <span><CIcon size="sm" name="cil-print" /></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              class="table-bordered c-table c-table-main"
              :bordered="true"
              :small="true"
              :items="items"
              :fields="fields"
              :sorter="{ external: true, resetable: true }"
              @update:sorter-value="filterTable"
              :columnFilter="{ external: true, lazy: true }"
              @update:column-filter-value="filterTable"
              :column-filter-value.sync="columnFilter"
              :loading="loading"
            >
              <template #no-items-view>
                <div class="no-items-view">
                  {{
                    loading
                      ? "Cargando datos..."
                      : "No existen recaudaciones"
                  }}
                  <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
                </div>
              </template>
              <!-- filters -->
              <template #detail-filter>
                <b-button
                  @click="reload"
                  variant="secondary"
                  size="sm"
                  title="Recargar tabla"
                >
                  <CIcon size="sm" name="cil-reload" />
                </b-button>
                <b-button
                  @click="clean"
                  variant="secondary"
                  size="sm"
                  title="Limpiar filtros"
                >
                  <CIcon size="sm" name="cil-filter-x" />
                </b-button>
              </template>
              <!-- data -->
              <template #id="{ index }">
                <td>{{ (page - 1) * limit + (index + 1) }}</td>
              </template>
              <template #created_at="{ item }">
                <td class="text-center">
                  {{ item.created_at | date("DD-MM-YYYY", "DD-MM-YYYY H:i") }}
                </td>
              </template>
              <template #code_number="{ item }">
                <td class="text-center">
                  {{ item.code_number }}
                </td>
              </template>
              <template #customer_nit_document_fullname="{ item }">
                <td>
                  {{ `${item.customer_nit_document_fullname}` }}
                </td>
              </template>
              <template #other_sales="{ item }">
                <td>
                  {{ item.other_sales | other_sales }}
                </td>
              </template>
              <template #total_with_discounts_and_fines="{ item }">
                <td class="text-right">
                  {{ item.total_with_discounts_and_fines | currency }}
                </td>
              </template>
              <template #detail>
                <td></td>
              </template>
              <template #footer>
                <tr>
                  <td colspan="5"></td>
                  <td><b>TOTAL OTRAS VENTAS:</b></td>
                  <td class="text-right">
                    <b> Bs. {{ totalOtherSale | currency }}</b>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="5"></td>
                  <td><b>TOTAL PENSIONES:</b></td>
                  <td class="text-right">
                    <b> Bs. {{ totalRegistration | currency }}</b>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="5"></td>
                  <td><b>TOTAL VENTAS: </b></td>

                  <td class="text-right">
                    <b> Bs. {{ total_sales | currency }}</b>
                  </td>
                  <td></td>
                </tr>
              </template>
            </CDataTable>
          </CCardBody>
          <div>
            <CPagination
              :activePage.sync="page"
              :pages="pages"
              size="sm"
              align="center"
              @update:activePage="updateTable"
            />
            <TableRecords
              :total="total"
              :loading="loading"
              :from="from"
              :to="to"
              :page="page"
            />
          </div>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import {
  BAlert,
  BModal,
  BButton,
  BButtonGroup,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import Sales from "@/plugins/services/sales";

export default {
  name: "IncomeList",
  components: {
    BAlert,
    BModal,
    BButton,
    BButtonGroup,
    BFormSelect,
    BFormSelectOption,
    TableRecords,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
          _style: "width: 8px;",
        },
        {
          key: "created_at",
          label: "Fecha",
          _style: "min-width: 100px;",
          filter: false,
        },
        {
          key: "code_number",
          label: "Código",
          _style: "width: 7%;",
        },

        {
          key: "customer_nit_document_nit_name",
          label: "Cliente",
          sorter: false,
          _style: "min-width: 160px;",
        },
        {
          key: "other_sales",
          label: "Tipo de venta",
          sorter: false,
          filter: false,
          _style: "min-width: 100px;",
        },
        {
          key: "payment_method_name",
          label: "Método de pago",
          sorter: false,
          filter: false,
          _style: "width: 15%;",
        },
        {
          key: "total_with_discounts_and_fines",
          filter: false,
          label: "Total",
          _style: "width: 10%;",
        },
        {
          key: "detail",
          label: "",
          sorter: false,
          _style: "width: 90px;",
        },
      ],
      items: [],
      teacher: null,
      columnFilter: {
        column: null,
        asc: false,
        created_at_from: this.$moment().format("DD-MM-YYYY"),
        created_at_to: this.$moment().format("DD-MM-YYYY"),
      },
      enabledOptions: Constants.enabledOptions,
      syllabusOptions: [],
      page: 0,
      pages: 0,
      limit: 20,
      from: 0,
      to: 0,
      total: 0,
      totalOtherSale: 0,
      totalRegistration: 0,
      total_sales: 0,
      loading: true,
      dataEmit: { modalShow: false, data: null },
    };
  },
  mounted() {
    this.getAll(this.columnFilter);
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      Sales.allIncome(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
        this.totalOtherSale = res.data.totalOtherSale;
        this.totalRegistration = res.data.totalRegistration;
        this.total_sales = res.data.total_sales;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = {
        column: null,
        asc: false,
        created_at_from: this.$moment().format("DD-MM-YYYY"),
        created_at_to: this.$moment().format("DD-MM-YYYY"),
      };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter);
    },
    print() {
      let cFilter = this.columnFilter;
      let querystring = Utils.encodeQueryData(cFilter);
      let teacherSchedule = `${process.env.MIX_APP_API_ENDPOINT}/sales/income-pdf?${querystring}`;
      Utils.printPdf(teacherSchedule);
    },
  },
};
</script>
